import { Typography } from '@archer-technologies/ui-components';
import { DataTypeProvider, DataTypeProviderProps } from '@devexpress/dx-react-grid';
import * as React from 'react';

interface DataTypeProviderLocaleProps extends DataTypeProviderProps {
  dateTimeLocale: any;
}

const hasComma = (dateValue: string) => {
  const expression = /[,]/g;
  return expression.test(dateValue);
};

const createDateFormatter =
  (dateTimeLocale: any) =>
  ({ value }: DataTypeProvider.ValueFormatterProps) => {
    let date: any = '';

    if (value) {
      date = dateTimeLocale ? dateTimeLocale(value) : value.toLocaleString('en-US');
    }
    return (
      <Typography variant="body1" color="textPrimary" align={hasComma(date) ? 'left' : 'right'}>
        {date}
      </Typography>
    );
  };

const DateTypeProvider = (props: DataTypeProviderLocaleProps) => {
  const { dateTimeLocale } = props;
  const DateFormatter = React.useMemo(() => createDateFormatter(dateTimeLocale), [dateTimeLocale]);

  return <DataTypeProvider formatterComponent={DateFormatter} {...props} />;
};

export { createDateFormatter, DateTypeProvider };
